import { normalizeUrl } from './utils/normalize-url';
var normalizeVideoQuality = function (quality) { return parseInt(quality, 10); };
export var getWixVideoPreviewUrls = function (item, settings) {
    if (item.fileOutput && item.fileOutput.video) {
        return item.fileOutput.video
            .filter(function (video) { return normalizeVideoQuality(video.quality) <= normalizeVideoQuality(settings.videoPreviewQuality); })
            .map(function (video) { return normalizeUrl("".concat(settings.videoFilesUrl, "/").concat(video.url)); });
    }
    return null;
};
//# sourceMappingURL=get-wix-video-preview-urls.js.map